import { PagePending } from "@/components/ui/PagePending";
import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/supplier/$supplierId/messages")({
  pendingComponent: PagePending,
  component: lazyRouteComponent(() => import("./+MessagesLayout")),
  head: () => ({
    meta: seo({ title: "Messages" }),
  }),
});
